import { createContext } from 'react'
import type { FrameEvent } from '../../core/frame.js'

/**
 * Frame statistics exposed to React components.
 *
 * Updated by Ink after each render frame. Components read this via
 * the `useFps` hook to display frame rate and render timing.
 */
export type FrameStats = {
	/** Subscribe to frame events. Returns unsubscribe function. */
	subscribe: (cb: (event: FrameEvent) => void) => () => void
}

const FrameStatsContext = createContext<FrameStats | null>(null)
FrameStatsContext.displayName = 'FrameStatsContext'

export default FrameStatsContext
